export default {
  message: {
    hello: "你好",
    welcome: "欢迎使用我们的应用",
    login: "登录",
    cn: "简体中文",
    fcn: "繁體中文",
    en: "English",
    back: "返回",
    register: "注册",
    home: "首页",
    notice: "通知",
    customerService: "客服",
    pictures: "拍照",
    record: "记录",
    phone: "手机号",
    inviteCode: "邀请码",
    nextStep: "下一步",
    gologin: "去登录",
    uploadIdCard: "请上传身份证的正面",
    uploadface: "请用手机拍一张正脸照片",
    yourLeader: "你的所属主管",
    callService: "拨打客服",
    sickLeave: "病假",
    personalLeave: "事假",
    annualLeave: "年假",
    CompensatoryLeave: "调休",
    adjustment: "调整",
    other: "其他",
    messgaeLeader: "留言主管",
    plcPhone: "请输入手机号",
    punchin: "打卡",
    managerPhone: "经理手机号",
    correctFormat: "正确格式的",
    pleaseEnter: "请输入",
    yourLeaderkf: "当前值班的客服",
    pictack: "请先拍照",
    takePicture: "拍摄",
    takeMorePicture: "重新拍摄",
    loninin: "打卡",
    errLonin: "未在打卡范围",
    dakkz: "打卡中",
    loginTwo: "该手机已经注册过！",
    restaurant: "餐厅名称",
    onwork_at: "上班打卡时间",
    offwork_at: "下班打卡时间",
    fromGallery: "从相册中选择",
    idCardErr: "身份证识别失败，请重新上传",
    noMore: "没有更多了",
    submitRec: "提交记录",
    submit: "提交",
    msgType: "留言类型",
    msgTime: "留言时间",
    read: "已读",
    noRead: "未读",
    uploadSuccess: "上传成功",
    takeFirst: "请先拍摄照片",
    submitTime: "提交时间",
    cancelAccount: "注销账户",
    zhuanguz: "您的专属主管",
    gengin: "更新App",
    Account: "账户",
    messaad: "消息",
    jinglli: "经理端",
    employees: "员工",
    eatDinn: "餐厅",
    function1: "功能",
    my: "我的",
    name: "姓名",
    supervisor: "上级",
    lijibo: "立即撥打客服",
    cancel: "取消",
    lijibod: "立即拨打",
    upAppUse: "请更新App使用此功能！",
    versionNew: "檢測到新版本，是否立即安裝？",
    upumme: "立即更新",
    InstallNow: "立即安装",
    districts: "地区",
    versionNew1: "檢測到新版本，是否立即更新？",
    onwork: "上班",
    assist: "协助",
    tips: "提示",
    valuationSuccess: "评价成功",
    bad: "差",
    verygood: "非常好",
    general: "一般",
    unfinished: "未完成",
    offwork: "下班",
    arrangeClass: "请假",
    salary: "出粮",
    bodaa: "拨打",
    issue: "问题"
  }
};



// WEBPACK FOOTER //
// ./src/locales/cn.js